import { applicationApi } from 'common/api';
import { EventData, RegisterEventRequest } from 'models/event';

// Define a service using a base URL and expected endpoints
export const eventApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getList: builder.query<EventData[], void>({
      query: () => `bdc/event/list`,
      providesTags: [{ type: 'EventList', id: 'EventList' }],
    }),
    getDetail: builder.query<EventData, string>({
      query: (query) => `bdc/event/detail/${query}`,
      providesTags: [{ type: 'EventDetail', id: 'EventDetail' }],
    }),
    registerEvent: builder.mutation<void, RegisterEventRequest>({
      query: (body) => ({
        url: `bdc/event/register`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetListQuery, useGetDetailQuery, useRegisterEventMutation } = eventApi;
